<main id="covid19" #covid19 class="cdmx-app" role="main">
  <router-outlet></router-outlet>

</main>
